module.exports = __webpack_public_path__ + "static/media/blue-search.9b05f494.svg";